import React from 'react'
import "../bnne/Bnne.css"
import { Col, Container, Row } from 'react-bootstrap'
const Bnne = () => {
  return (
    <>
    <section id="banne">
      <Container>
        <Row>
          <Col lg={6}>
           <div class="banne_main">
              <h1>We are<br/> Extreamly
               <br/><span class="sp">Organic</span> </h1>
                <p>Donec sollicitudin molestie malesuada. Lorem ipsum <br/> dolor sit amet,consectetur adipiscing elit.</p>
                <button class="shop_now">shop now</button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  )
}

export default Bnne